import type { CSSProperties, FC, ReactNode } from "react";
import { createElement } from "react";
import BodyText from "./TextsNext/BodyText";

export const UnitText: FC<{ children: string; className?: string }> = ({
  className = "",
  children,
}) => (
  <BaseText
    className={className}
    color="text-slateus-200"
    font="font-roboto"
    weight="font-extralight"
  >
    {children}
  </BaseText>
);

export const TextInterLink: FC<{
  children: ReactNode;
  className?: string;
}> = ({ children, className: className = "" }) => (
  <BodyText className={`text-slateus-200 hover:underline ${className}`}>
    {children}
  </BodyText>
);

export type FontWeight =
  | "font-normal"
  | "font-light"
  | "font-extralight"
  | "font-medium";

type BaseTextProps = {
  children: ReactNode;
  className?: string;
  color?: string;
  font: "font-roboto" | "font-inter";
  inline?: boolean;
  lineHeight?: string;
  size?: string;
  style?: CSSProperties;
  tooltip?: string;
  weight?: FontWeight;
};

/**
 * Flexible base text component. Prefer shared text components based on it.
 */
export const BaseText: FC<BaseTextProps> = ({
  children,
  className = "",
  color = "text-white",
  font,
  inline = true,
  lineHeight = "leading-normal",
  size = "",
  style,
  tooltip,
  weight = "font-light",
}) =>
  createElement(
    inline ? "span" : "p",
    {
      className: `${font} ${className} ${color} ${weight} ${size} ${lineHeight}`,
      style: style,
      title: tooltip,
    },
    children,
  );

export const TimeFrameText: FC<{ children: ReactNode; className?: string }> = ({
  children,
  className = "",
}) => (
  <BaseText
    className={`tracking-widest ${className}`}
    size="text-xs"
    font="font-roboto"
    weight="font-normal"
  >
    {children}
  </BaseText>
);

export const TooltipTitle: FC<{ children: ReactNode }> = ({ children }) => (
  <BaseText font="font-inter" size="text-base md:text-lg" weight="font-normal">
    {children}
  </BaseText>
);
